import SearchIcon from "images/sprites/reb/svg/search-icon.svg";
import SearchField from "./search-field";
import PropTypes from "prop-types";

const propTypes = {
  showSearchField: PropTypes.bool,
  isHamburgerOpen: PropTypes.bool,
  setShowSearchField: PropTypes.func,
  analyticsObjectType: PropTypes.string,
  inputId: PropTypes.string,
};

const SearchBar = props => {
  const { showSearchField, isHamburgerOpen, setShowSearchField, analyticsObjectType, inputId } = props;
  return (
    <div
      data-test-id="searchbar-wrapper"
      className={`${isHamburgerOpen ? "flex m-6" : "hidden"} md:flex md:!-pl-4 items-center md:w-full !h-9 md:!h-11`}>
      <button
        data-test-id="searchbar-button"
        className={`${
          isHamburgerOpen ? "block" : "hidden"
        } [&>svg]:h-4 [&>svg]:w-4 md:[&>svg]:h-5 md:[&>svg]:w-5 md:block relative z-10 ${
          isHamburgerOpen && "left-4"
        } md:ml-0`}
        onClick={() => setShowSearchField(true)}>
        <SearchIcon data-test-id="searchbar-icon" />
      </button>
      <SearchField
        analyticsObjectType={analyticsObjectType}
        inputId={inputId}
        showSearchField={showSearchField}
        isHamburgerOpen={isHamburgerOpen}
        setShowSearchField={setShowSearchField}
      />
    </div>
  );
};

SearchBar.propTypes = propTypes;

export default SearchBar;
